<!-- temporary until old primary-navbar is removed -->
<div
  class="app-switcher gap-6 g-5 g-sm-9 container-fluid"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
  (keydown.escape)="escape()"
>
  @if (titleText()) {
    <div class="apps-header">
      <span>
        <p class="si-h4 lh-1 m-0">{{ titleText() | translate }}</p>
        @if (subtitleText()) {
          <p class="si-body text-secondary mt-4 mb-0">{{ subtitleText() | translate }}</p>
        }
      </span>
      <button
        type="button"
        class="btn btn-circle btn-tertiary-ghost"
        [attr.aria-label]="closeText() | translate"
        (click)="closeLaunchpad()"
      >
        <si-icon [icon]="icons.elementCancel" />
      </button>
    </div>
  }
  <div class="apps-scroll ms-n2 ps-2">
    @for (category of categories(); track category.name) {
      @if (!enableFavorites() || !hasFavorites() || $first || showAllApps) {
        <si-launchpad-category
          [class.pt-6]="!$first && !!category.name"
          [category]="category"
          [enableFavorites]="enableFavorites()"
          (favoriteChange)="toggleFavorite($event)"
        />
      }

      @if (enableFavorites() && $first && hasFavorites()) {
        <button
          type="button"
          class="btn btn-link btn-show-all dropdown-toggle text-decoration-none"
          [class.show]="showAllApps"
          (click)="showAllApps = !showAllApps"
        >
          <b>{{ (showAllApps ? showLessAppsText() : showMoreAppsText()) | translate }}</b>
          <si-icon class="link-icon dropdown-caret" [icon]="icons.elementDown2" />
        </button>
      }
    }
  </div>
</div>
